import dayjs from 'dayjs';
import { TimeUnit } from 'generated/graphql';
import { TimeRange } from 'v2/core/entities';
import { getDateRangeEndTime } from '.';

interface getDateRangeWindowOptions {
  timestamp: number;
  aggregatePeriod?: TimeUnit;
}

export const getDateRangeWindow = ({
  timestamp,
  aggregatePeriod,
}: getDateRangeWindowOptions): TimeRange => {
  const startTime = dayjs.unix(timestamp / 1000).tz();

  return {
    type: 'absolute',
    startAfter: startTime,
    endBefore: getDateRangeEndTime(startTime, aggregatePeriod),
  };
};
